<template>
  <div v-if="productData.productId" :class="rootCss" :style="showCard ? 'display:block;' : 'display:none'" style="height: 100%;">
    <div class="">
      <span class="pos-abs br-50 text-center closeQuickModal" v-on:click="closeModal" v-show="modal">
        <i class="lni lni-close"></i>
      </span>
      <div class="db-100 hp-0 quick-v-prod-name" v-show="showName">
        {{productData.productName}}
      </div>

      <div v-show="showImage" class="col-12 col-md-5 pos-rel quick-v-thumb">
        <div class="thumbnail_container">
          <div class="thumbnail">
            <picture>
              <source media="(max-width: 270px)" :srcset="mainImage.medium">
              <img :src="mainImage.large"
                   :alt="productData.productName">
            </picture>
          </div>
        </div>
      </div>

      <AdvCartProductCustomizationEditor
        ref="customizationEditor"
        :class="{
          'col-12': true,
          'col-md-6': this.modal
        }"
        v-if="null !== getCustomizationSchema"
        :schema="getCustomizationSchema"
      />

      <div
        :class="{
          'col-12': showImage,
          'col-md-7': showImage && null === getCustomizationSchema,
        }"
        class="d-flex-100 quick-v-info"
      >
        <div class="col-12 productDescription"
              v-show="showContent"
              v-html="productData.productDescription"
              ss-container>
        </div>
        <div class="col-6 quick-v-code" v-show="showContent && false">
          <span class="db-100 quick-v-code-ttl">{{ t('product_code.short') }}:</span>
          <span class="db-100 quick-v-code-id">{{productData.productId}}</span>
        </div>
        <div class="col-6 quick-v-code quick-v-barcode" v-show="showContent && productData.barCodes.length && false">
          <span class="db-100 quick-v-code-ttl">{{ t('product_barcode') }}:</span>
          <span class="db-100 quick-v-code-id">{{productData.barCodes[0]}}</span>
        </div>

        <variation-select
          v-if="hasVariationEntries && variationsActive"
          :product-id="productId">
        </variation-select>

        <ContactLensesMetaDropdown v-if="isUnderContactLenses && contactLensesMetaData"
          @selected="selected"
          @active-field="setEditableDropdown"
          :metadata='contactLensesMetaData'
          :productPrice="[productData.productFinalPrice, productData.vCCSign]"
        ></ContactLensesMetaDropdown>

        <!-- Attributes -->
        <attribute-select
          v-if="hasAttributes"
          v-on:matched-product-code="codeIdChanged"
          v-on:product-attribute-selected="attributeSelected"
          :product-id="productId"></attribute-select>

        <!-- Klarna Modal -->
        <div class="d-flex-100 klarna-section" v-if="isValidForKlarnaPayment">
            <div class="d-flex klarna-content">
              <img src="/ui/main/img/klarna-icon.svg" alt="Klarna icon">
              <div>
                {{ t('klarna.payment.amount.message', { params: [{KlarnaAmount: KlarnaAmount }] }) }}
                <span class="learn-more-klarna" @click="openModal">{{ t('learn.more') }}</span>
              </div>
            </div>
        </div>
        <KlarnaModal v-if="isModalVisible" @close="closeKlarnaModal"> </KlarnaModal>

        <div v-if="!isPhoneOrder" class="col-12 quick-v-price-row" v-show="showContent">
          <div class="row">
            <div class="col-9 col-sm-8 pl-0 price-chart-wrapper">
              <ProductPriceChartModal v-if="shouldDisplayChart"
              :product-id="productData.productId">
              </ProductPriceChartModal>
            </div>
            <div class="col-3 col-sm-4 product-page-price-wrapper p-0">
              <div class="quick-v-price-product-page">
                <!-- <span class="discount-percent-span" v-if="productData.productDisclosure">
                  {{ productData.productDisclosure }}
                </span> -->
                  <span class="price-row-lang" v-if="productData.productDisclosure">
                  {{ t('only') }}
                </span>
                  <span class="final-price-span"
                        v-html="priceWithSign(productData.productFinalPrice, getSign())">
                </span>
              </div>
            </div>
            <div class="quick-v-price-product-page-mobile">
              <div class="col-6 p-0">
                <ProductPriceChartModal v-if="shouldDisplayChart"
                                        :product-id="productData.productId">
                </ProductPriceChartModal>
              </div>
              <div class="col-6 p-0 mobile-price-row-wrapper">
                <!-- <span class="mobile-original-price" v-if="productData.productDisclosure">
                  {{ productData.productOldPrice }}
                </span> -->
                <span class="mobile-price-value"
                  v-html="priceWithSign(productData.productFinalPrice, getSign())">
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 quick-v-quantity quick-v-unavailable"
              v-if="productCodeId && (inactiveProduct || unavailableProduct) && !isPhoneOrder">
          <span v-show="inactiveProduct && config.showInactiveProductCodes">
            {{ t('product_status.unavailable') }}
          </span>
          <span v-show="unavailableProduct && !inactiveProduct">
            {{ t('product_status.unavailable.out_of_stock') }}
          </span>
        </div>
        <!-- Qty-->
        <div
          class="col-6 quick-v-quantity"
          v-else-if="showInputGroup">
          <adv-product-input-spinner
            :product-code-id="productCodeId"
            :watch-for-product-code-id-changes="false"
            :max-amount="maxAmountForInputSpinner"
            v-bind:quantity="quantity"
            v-on:quantity-changed="quantityChanged"></adv-product-input-spinner>
        </div>
        <!-- Btn-->
        <div class="quick-v-tocart"
          :class="addToCartCol">
          <adv-cart-button
            class="addToCart"
            :unavailable="unavailableProduct || cartLimitForProductReached || !this.lensesAddToCartIsClickable && this.isUnderContactLenses"
            :cart-limit-reached="cartLimitForProductReached"
            :has-attributes="hasAttributes"
            :selected-attribute-id="selectedAttributeId"
            :show-add-to-cart-btn-text="showAddToCartBtnText"
            :is-under-contact-lenses="isUnderContactLenses"
            v-on:btn-click="addToCard"
            :stock="productCodeData.productStock"
            :progress="progress"
            :productId="this.productId"
            v-bind:quantity="quantity"></adv-cart-button>
        </div>
        <a v-if="showPrescriptionBtn" :href="'/συνταγολογιο/' + productSlug" class="prescription-button-wrapper">
          {{ t('prescription.button.text') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, get, isEmpty, some } from 'lodash-es'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AttributeSelect from './attributes/AttributeSelect'
import AdvCartButton from './AdvCartButton'
import AdvProductInputSpinner from './AdvProductInputSpinner'
import VariationSelect from './variations/VariationSelect'
import { mapActions, mapGetters } from 'vuex'
import AdvCartProductCustomizationEditor from './cartProductCustomizations/AdvCartProductCustomizationEditor.vue'
import ContactLensesMetaDropdown from './ContactLensesMetaDropdown.vue'
import ProductPriceChartModal from './product/ProductPriceChartModal.vue'
import KlarnaModal from './KlarnaModal.vue'

export default {
  name: 'AdvProductCard',
  components: {
    AttributeSelect,
    VariationSelect,
    AdvCartButton,
    AdvProductInputSpinner,
    AdvCartProductCustomizationEditor,
    ContactLensesMetaDropdown,
    ProductPriceChartModal,
    KlarnaModal
  },
  props: {
    productId: {
      type: Number
    },
    showName: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    showImage: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    },
    showInputGroup: {
      type: Boolean,
      default: true
    },
    showAddToCartBtnText: {
      type: Boolean,
      default: false
    },
    isUnderContactLenses: {
      type: Boolean,
      default: false
    },
    contactLensesMetaData: {
      type: Object,
      default: null
    },
    showPrescriptionBtn: {
      type: Boolean,
      default: false
    },
    productSlug: {
      type: String,
      default: ''
    }
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      },
      selectedMetaData: {},
      isEditableField: {
        left: false,
        right: false
      },
      lensesAddToCartIsClickable: false,
      isModalVisible: false
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    ...mapGetters([
      'getUniqueProductVariationValueIds',
      'cartProductWithCustomizationQuantity',
      'cartProductCodeQuantity',
      'getSelectedCurrency'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    ...mapGetters('productChart', ['getProductChartSettings']),
    rootCss () {
      if (this.modal) {
        return 'd-none'
      }
      return ''
    },
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    getCustomizationSchema () {
      if (!('customizationSchemaId' in this.productData) || null === this.productData.customizationSchemaId) {
        return null
      }
      if (('customizationSchemaRange' in this.productData) && this.productData.customizationSchemaRange !== null) {
        const from = this.productData.customizationSchemaRange.from
        const to = this.productData.customizationSchemaRange.to
        if (from !== null && new Date(from) > new Date()) {
          return null
        }
        if (to !== null && new Date(to) < new Date()) {
          return null
        }
      }
      const schema = this.getSchemaById(this.productData.customizationSchemaId)
      if (null === schema || !('schema' in schema) || ('is_active' in schema && false === schema.is_active)) {
        return null
      }
      return cloneDeep(schema)
    },
    hasVariationEntries () {
      return this.getUniqueProductVariationValueIds.length > 0
    },
    productPriceClass () {
      return 'col-xs-12 ' + (this.productData.productFinalPrice === this.productData.productOldPrice ? '' : 'col-sm-4 ') + 'text-right productItemMainPrice'
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0 || this.isProductInAvailabilityDate
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      const currentDate = Date.now()
      return (
        (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
        (availableUntil != null && currentDate > new Date(availableUntil).getTime())
      )
    },
    cartLimitForProductReached () {
      return this.productCodeData.productStock === this.cartQuantity
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      if (
        null !== this.getCustomizationSchema &&
        !isEmpty(get(this, ['$refs', 'customizationEditor', 'getSchema']))
      ) {
        return this.cartProductWithCustomizationQuantity(
          this.productCodeId,
          this.$refs.customizationEditor.getSchema,
          0
        )
      }
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    },
    variationsActive () {
      return store.getters.getVariationsActive
    },
    productChartSettings () {
      return this.getProductChartSettings
    },
    hasDiscount () {
      return this.productChartSettings?.enabled &&
        this.productData.priceTracking?.shouldDisplay &&
        this.productData.priceTracking?.discountPass
    },
    hasDiscountNoPriceTracking () {
      return !this.productChartSettings?.enabled && this.productData.productHasDiscount
    },
    addToCartCol () {
      return this.showInputGroup ? 'col-md-6' : 'col-md-12'
    },
    shouldDisplayChart () {
      if (this.productChartSettings?.enabled &&
        (this.productChartSettings?.enabledGraphs || this.productChartSettings?.enabledAllGraphs)) {
        return true
      }
      return false
    },
    isPhoneOrder () {
      return this.productData.isPhoneOrder === 1
    },
    isValidForKlarnaPayment () {
      return this.productData.productFinalPrice < 3000
    },
    KlarnaAmount () {
      const klarnaAmount = this.productData.productFinalPrice / 3
      return klarnaAmount.toFixed(2)
    }
  },
  methods: {
    ...mapActions(['addToCartClicked', 'setSelectedProductCodeId', 'setSelectedAttributeId']),
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        this.setSelectedAttributeId(null)
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * this.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return this.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      this.setSelectedAttributeId(attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        this.setSelectedProductCodeId(this.productCodeId)
        this.setMainImage()
      }
    },
    quantityChanged (quantity) {
      this.quantity = quantity
    },
    addToCard () {
      if ('customizationEditor' in this.$refs && !this.$refs.customizationEditor.validate()) {
        return
      }
      this.progress = true
      const cartPayload = {
        productCodeId: this.productCodeId,
        quantity: this.cartQuantity + this.quantity,
        recommendationId: this.recommendationId,
        recommendationType: this.recommendationType
      }

      if (this.isUnderContactLenses && this.contactLensesMetaData !== null) {
        cartPayload.metaData = this.selectedMetaData
      }

      if (this.getCustomizationSchema !== null) {
        cartPayload.quantity = this.quantity
        cartPayload.cartProductCustomizations = this.$refs.customizationEditor.getSchema
      }
      this.addToCartClicked(cartPayload).then(() => {
        this.progress = false
        this.quantity = 1
      })
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    },
    lensesAddToCartIsClickableValidation() {
      if (!this.isUnderContactLenses) {
        return true;
      }

      let isLeftEyeComplete = true;
      let isRightEyeComplete = true;

      if (this.selectedMetaData.left && this.isEditableField['left']) {
        isLeftEyeComplete = this.isEyeComplete('left')
      }
      if (this.selectedMetaData.right && this.isEditableField['right']) {
        isRightEyeComplete = this.isEyeComplete('right')
      }

      this.lensesAddToCartIsClickable = isLeftEyeComplete && isRightEyeComplete && (this.isEditableField['left'] || this.isEditableField['right'])
    },
    isEyeComplete (eye) {
      const metadata = this.selectedMetaData[eye]
      if (!metadata) {
        return false
      }
      const isEditableFieldActive = this.isEditableField[eye]
      const metadataKeys = Object.keys(metadata)
      const requiredKeys = Object.keys(this.contactLensesMetaData)

      return metadataKeys.length === requiredKeys.length && isEditableFieldActive
    },
    selected (eye) {
      this.selectedMetaData[eye.eye] = eye.values
      this.lensesAddToCartIsClickableValidation()
    },
    setEditableDropdown (lensData) {
      this.isEditableField[lensData.eye] = lensData.value
      this.lensesAddToCartIsClickableValidation()
    },
    openModal ()  {
      this.isModalVisible = true;
    },
    closeKlarnaModal () {
      this.isModalVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.klarna-section {
  border: 1px solid #DBDBDB;
  padding: 15px;
  .klarna-content {
    color: #000000;
    font-size: 0.75rem;
    font-weight: 400;
    gap: 20px;
    .learn-more-klarna {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
